import {
  roundMoney,
  type MoneyScale,
  DEFAULT_MONEY_SCALE,
  moneyScaleForCurrency,
} from '../money';

let activeScale: MoneyScale = DEFAULT_MONEY_SCALE;

/** Alcance síncrono de evaluación (motor de promos / POS / Edge). */
export function runWithMoneyScale<T>(scale: MoneyScale, fn: () => T): T {
  const prev = activeScale;
  activeScale = scale;
  try {
    return fn();
  } finally {
    activeScale = prev;
  }
}

export function resolvePromotionMoneyScale(currency?: string | null): MoneyScale {
  return moneyScaleForCurrency(currency ?? DEFAULT_MONEY_SCALE.currency);
}

/** Redondeo monetario half-up según moneda activa en la evaluación. */
export function roundArsHalfUp(value: number): number {
  return roundMoney(value, activeScale);
}

/** Redondeo explícito (tests o callers fuera de runWithMoneyScale). */
export function roundMoneyHalfUp(value: number, scale: MoneyScale = DEFAULT_MONEY_SCALE): number {
  return roundMoney(value, scale);
}
